import axios from "axios";

export const noAuthAxios = axios.create();

export const authAxios = axios.create();

authAxios.interceptors.request.use(config => {
    const token = localStorage.token;
    config.headers.Authorization = `Bearer ${token}`;
    return config;
})

// Thunk helper
export const handleApiError = (error, callback) => {
    if (!error.response) {
        throw error
    }
    const {
        data: {
            message,
            success
        } = {},
        status
    } = error.response;

    return callback({
        message,
        status,
        success,
    })
}